/**
 * BL-2337 — the client-minted id an offline create carries, so a retried
 * create returns the record it already made instead of making another.
 *
 * One declaration for every create door that takes it (inventory create, the
 * place-in-auction `newLot`, internal-note create). It is a UUID because the
 * column is `uuid`: anything else would reach Postgres as a 22P02.
 * Client-bundle-safe.
 */
import { z } from '@auctogon/core/zod';

/** Refusal copy for a malformed op id — one source for the schema and its tests. */
export const OFFLINE_OP_ID_INVALID_MESSAGE = 'clientOpId must be a UUID';

/** Refusal copy for two creates in one request sharing an op id. */
export const OFFLINE_OP_ID_REPEATED_MESSAGE = 'Each new lot needs its own clientOpId';

/** The optional `clientOpId` field on a create payload. */
export const OfflineOpIdSchema = z.string().uuid(OFFLINE_OP_ID_INVALID_MESSAGE);
